
import { getImage } from "@/service/image.service";
import { Image } from "@/types/Image.type";
import { defineComponent, PropType, ref } from "@vue/runtime-core";

interface ImageData extends Image {
  title?: string;
}

export default defineComponent({
  components: {},
  props: {
    thumbnail: {
      type: Boolean,
      default: true,
    },
    images: {
      type: Array as PropType<ImageData[]>,
      required: true,
    },
    modal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      src: ref<{ [name: string]: string }>({}),
    };
  },
  created() {
    this.loadImage();
  },
  unmounted() {
    // - free memory
    Object.values(this.src).forEach((value) => URL.revokeObjectURL(value));
  },
  methods: {
    formatDate(datetime: Date) {
      let dateTime = undefined;
      if (datetime !== null) {
        const dateString: Date = new Date(`${datetime}`);

        dateTime = this.$d(new Date(dateString), "dateTime");
      }
      return dateTime !== undefined ? dateTime : "-";
    },
    loadImage() {
      this.images.forEach((image) => {
        if (!image?.fileName || this.src[image.fileName]) return;
        getImage(image.fileName, this.thumbnail)
          .then((res) => {
            if (!image?.fileName) return;
            this.src[image.fileName] = res;
          })
          .catch(void 0);
      });
    },
    checkTime(dateTime: Date) {
      if (dateTime !== null) {
        // Variables para tener en cuenta los tiempos
        const MIN_WARNING = 50;
        const MAX_WARNING = 70;
        // Calculamos la diferencia de tiempo
        const dateString: Date = new Date(`${dateTime}`);
        const lastTime = dateString.getTime();
        const nowTime = Date.now();

        const timeDiference = Math.floor((nowTime - lastTime) / 1000 / 60);

        // Comprobamos si la diferencia del tiempo pasa del tiempo establecido para el aviso
        if (timeDiference >= MIN_WARNING && timeDiference <= MAX_WARNING) {
          return "warning";
        } else if (timeDiference > MAX_WARNING) {
          return "danger";
        }

        return undefined;
      }
    },
  },
  watch: {
    images: {
      handler() {
        this.loadImage();
      },
      deep: false,
    },
  },
});
